import React, { useEffect } from 'react';

const PlanSelectionModal = ({ onClose }) => {
    
    // Fecha com ESC
    useEffect(() => {
        const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [onClose]);

    const handleCheckout = (planId) => {
        // AQUI ENTRARÁ O LINK DO STRIPE/KIWIFY NO FUTURO
        alert(`Redirecionando para checkout seguro: PLANO ${planId.toUpperCase()}`);
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#20243B]/90 backdrop-blur-sm animate-fade-in-up">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl overflow-hidden flex flex-col md:flex-row relative">
                
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-red-500 z-10">
                    <i className="fas fa-times text-xl"></i>
                </button>

                {/* COLUNA VISUAL (MARKETING) */}
                <div className="md:w-2/5 bg-gradient-to-br from-[#20243B] to-[#1a1e30] p-8 text-white flex flex-col justify-between relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 opacity-10"><i className="fas fa-crown text-9xl"></i></div>
                    
                    <div className="relative z-10">
                        <span className="bg-[#C5A059] text-[#20243B] text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-widest mb-4 inline-block">
                            Acesso Premium
                        </span>
                        <h2 className="text-3xl font-serif font-bold mb-4 leading-tight">
                            Desbloqueie a <br/><span className="text-[#C5A059]">Alta Performance</span>
                        </h2>
                        <p className="text-gray-300 text-sm leading-relaxed mb-6">
                            A metodologia que transforma estudantes em advogados de elite. Acesso total ao ecossistema RDA.
                        </p>
                    </div>

                    <div className="space-y-3 relative z-10">
                        <div className="flex items-center gap-3 text-sm">
                            <i className="fas fa-check-circle text-[#C5A059]"></i>
                            <span>Vídeo Aulas</span>
                        </div>
                        <div className="flex items-center gap-3 text-sm">
                            <i className="fas fa-check-circle text-[#C5A059]"></i>
                            <span>Banco de Peças</span>
                        </div>
                        <div className="flex items-center gap-3 text-sm">
                            <i className="fas fa-check-circle text-[#C5A059]"></i>
                            <span>Laboratório Mentoria</span>
                        </div>
                    </div>
                </div>

                {/* COLUNA PLANOS */}
                <div className="md:w-3/5 p-8 bg-gray-50 flex flex-col justify-center">
                    <h3 className="text-center text-gray-800 font-bold text-lg mb-8 uppercase tracking-wide">Escolha seu Plano</h3>
                    
                    <div className="grid gap-4">
                        {/* PLANO MENSAL */}
                        <div className="bg-white border border-gray-200 rounded-xl p-4 flex items-center justify-between hover:border-[#C5A059] cursor-pointer transition-all group shadow-sm hover:shadow-md" onClick={() => handleCheckout('mensal')}>
                            <div className="flex items-center gap-4">
                                <div className="w-6 h-6 rounded-full border-2 border-gray-300 group-hover:border-[#C5A059] flex items-center justify-center">
                                    <div className="w-3 h-3 rounded-full bg-[#C5A059] opacity-0 group-hover:opacity-100 transition-opacity"></div>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-800">Mensal Flex</h4>
                                    <p className="text-xs text-gray-500">Acesso completo. Cancele quando quiser.</p>
                                </div>
                            </div>
                            <div className="text-right">
                                <span className="block text-lg font-black text-[#20243B]">R$ 49,90</span>
                                <span className="text-[10px] text-gray-400 uppercase">/mês</span>
                            </div>
                        </div>

                        {/* PLANO SEMESTRAL (DESTAQUE) */}
                        <div className="bg-white border-2 border-[#C5A059] rounded-xl p-4 flex items-center justify-between cursor-pointer transition-all shadow-lg relative transform scale-105 z-10" onClick={() => handleCheckout('semestral')}>
                            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C5A059] text-[#20243B] text-[9px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-sm">
                                Mais Escolhido
                            </div>
                            <div className="flex items-center gap-4">
                                <div className="w-6 h-6 rounded-full border-2 border-[#C5A059] flex items-center justify-center">
                                    <div className="w-3 h-3 rounded-full bg-[#C5A059]"></div>
                                </div>
                                <div>
                                    <h4 className="font-bold text-[#20243B]">Semestral (OAB)</h4>
                                    <p className="text-xs text-gray-500">Foco total até a aprovação.</p>
                                </div>
                            </div>
                            <div className="text-right">
                                <span className="block text-xl font-black text-[#C5A059]">R$ 29,90</span>
                                <span className="text-[10px] text-gray-400 uppercase">/mês</span>
                            </div>
                        </div>

                        {/* PLANO ANUAL */}
                        <div className="bg-white border border-gray-200 rounded-xl p-4 flex items-center justify-between hover:border-[#C5A059] cursor-pointer transition-all group shadow-sm hover:shadow-md" onClick={() => handleCheckout('anual')}>
                            <div className="flex items-center gap-4">
                                <div className="w-6 h-6 rounded-full border-2 border-gray-300 group-hover:border-[#C5A059] flex items-center justify-center">
                                    <div className="w-3 h-3 rounded-full bg-[#C5A059] opacity-0 group-hover:opacity-100 transition-opacity"></div>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-800">Anual VIP</h4>
                                    <p className="text-xs text-gray-500">Mentoria + Banco de Peças + Grupo.</p>
                                </div>
                            </div>
                            <div className="text-right">
                                <span className="block text-lg font-black text-[#20243B]">R$ 19,90</span>
                                <span className="text-[10px] text-gray-400 uppercase">/mês</span>
                            </div>
                        </div>
                    </div>

                    <button onClick={() => handleCheckout('semestral')} className="mt-8 w-full bg-[#20243B] text-white py-4 rounded-xl font-bold uppercase tracking-wider shadow-xl hover:bg-[#1a1e30] transition-transform active:scale-95 flex items-center justify-center gap-2">
                        Começar Agora <i className="fas fa-arrow-right"></i>
                    </button>
                    
                    <p className="text-center text-[10px] text-gray-400 mt-4">
                        <i className="fas fa-lock mr-1"></i> Pagamento seguro processado por Stripe.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PlanSelectionModal;